/**
 * O carregador do Google Maps do navegador (26/08, pedido do Lucas).
 *
 * A CHAVE ABAIXO NÃO É SEGREDO — e isso é de propósito, não descuido. Chave de
 * navegador do Google é pública por construção (vai no HTML de qualquer jeito);
 * a proteção é a restrição registrada NELA no Google Cloud: só funciona
 * chamada a partir dos NOSSOS domínios (sistema-cd-*.web.app, sistema.ademaldo.com.br,
 * localhost) e só
 * para a Maps JavaScript API. Roubá-la não serve para nada fora daqui.
 * É diferente da MAPS_STATIC_KEY do backend, que é secreta e nunca sai do
 * servidor — regra 3 do projeto continua valendo para chaves DE VERDADE.
 *
 * Carrega uma vez, na primeira tela que pedir; as demais reaproveitam.
 */

const CHAVE_NAVEGADOR = 'AIzaSyC6o-y1qDZ7f39jRaOG6sNeoiSdBXg2pZA';

let carregando: Promise<typeof google.maps> | undefined;

export function carregarGoogleMaps(): Promise<typeof google.maps> {
  if (carregando) return carregando;
  carregando = new Promise((resolve, reject) => {
    const w = window as { google?: typeof google; __mapsProntas?: () => void };
    if (w.google?.maps?.Map) {
      resolve(w.google.maps);
      return;
    }
    w.__mapsProntas = () => resolve((window as unknown as { google: typeof google }).google.maps);
    const s = document.createElement('script');
    s.src =
      `https://maps.googleapis.com/maps/api/js?key=${CHAVE_NAVEGADOR}` +
      `&v=weekly&language=pt-BR&region=BR&loading=async&callback=__mapsProntas`;
    s.onerror = () => {
      carregando = undefined; // um tropeço de rede não pode condenar até recarregar
      reject(new Error('O Google Maps não carregou — confira a internet e tente de novo.'));
    };
    document.head.appendChild(s);
  });
  return carregando;
}
